import { useState } from 'react';
import { Button, Image, Typography } from 'antd';
import type { SetupWorkholding } from './setupWorkholding';

const { Text } = Typography;

/** The jaw configuration (and vise) the CAM programmer selected for a setup. */
const WorkholdingDetails = ({ workholding }: { workholding: SetupWorkholding | null }) => {
	const [overlayVisible, setOverlayVisible] = useState(false);
	const jaw = workholding?.jaw;
	if (!jaw) {
		return <Text type="secondary">No jaws selected</Text>;
	}

	const assemblyName =
		typeof jaw.jaw_assembly === 'object' && jaw.jaw_assembly !== null
			? jaw.jaw_assembly.name
			: null;

	return (
		<div className="flex flex-row items-center gap-3">
			{jaw.thumbnail && (
				<div className="h-48 w-48 shrink-0 overflow-hidden">
					<Image
						src={jaw.thumbnail}
						alt="Jaw configuration thumbnail"
						width={192}
						height={192}
						style={{ objectFit: 'contain' }}
					/>
				</div>
			)}
			<div className="flex flex-col items-start">
				{assemblyName && <Text strong>{assemblyName}</Text>}
				<Text type="secondary">{jaw.name ?? 'Unnamed configuration'}</Text>
				{workholding?.vise && <Text type="secondary">Vise {workholding.vise}</Text>}
				{jaw.wireframe_overlay && (
					<>
						<Button className="mt-2" onClick={() => setOverlayVisible(true)}>
							View Overlay
						</Button>
						<Image
							src={jaw.wireframe_overlay}
							alt="Jaw configuration overlay"
							style={{ display: 'none' }}
							preview={{
								visible: overlayVisible,
								onVisibleChange: setOverlayVisible,
							}}
						/>
					</>
				)}
			</div>
		</div>
	);
};

export default WorkholdingDetails;
